import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { WarningOctagon } from "@phosphor-icons/react";

const MANAGERS = ["admin", "supervisor"];

export const EscalationSettings = () => {
  const [cfg, setCfg] = useState(null);
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    api.get("/settings/escalation").then(({ data }) => setCfg(data)).catch(() => setCfg(null));
    api.get("/available-agents").then(({ data }) => setAgents(data.filter((a) => !MANAGERS.includes(a.role)))).catch(() => {});
  }, []);

  const save = async (next) => {
    const prev = cfg;
    setCfg(next);
    try {
      const { data } = await api.put("/settings/escalation", next);
      setCfg(data);
      toast.success("Escalamiento actualizado");
    } catch {
      setCfg(prev);
      toast.error("No se pudo guardar");
    }
  };

  const toggleAgent = (id, on) => {
    const ids = cfg.disabled_agent_ids.filter((x) => x !== id);
    save({ ...cfg, disabled_agent_ids: on ? ids : [...ids, id] });
  };

  if (!cfg) return null;
  return (
    <div className="rounded-md border border-border p-4 mb-6" data-testid="escalation-settings">
      <div className="flex items-center justify-between gap-4 mb-1">
        <div className="flex items-center gap-1.5 text-sm font-semibold"><WarningOctagon size={14} /> Botón Escalar de los agentes</div>
        <Switch checked={cfg.enabled} onCheckedChange={(v) => save({ ...cfg, enabled: v })} data-testid="escalation-global-switch" />
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        {cfg.enabled
          ? "Activo para el equipo. Puedes desactivarlo para agentes específicos."
          : "Desactivado para todo el equipo. Los agentes verán el botón Escalar bloqueado con un aviso."}
      </p>
      <div className={`grid grid-cols-1 md:grid-cols-2 gap-2 ${cfg.enabled ? "" : "opacity-50 pointer-events-none"}`} data-testid="escalation-agent-list">
        {agents.map((a) => (
          <div key={a.id} className="flex items-center justify-between rounded border border-border px-3 py-2">
            <div className="min-w-0">
              <div className="text-sm truncate">{a.name}</div>
              <div className="text-[11px] text-muted-foreground truncate">{a.email}</div>
            </div>
            <Switch checked={!cfg.disabled_agent_ids.includes(a.id)} onCheckedChange={(v) => toggleAgent(a.id, v)}
              data-testid={`escalation-agent-switch-${a.id}`} />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-3">Supervisores y administradores siempre pueden escalar.</p>
    </div>
  );
};

export default EscalationSettings;
